import ChartScreen from './ChartScreen';

export default ChartScreen;
